import styled from 'styled-components';
import Paper from '@mui/material/Paper';

export const CardContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: ${p => p.full ? '100%' : '420px'};

  // @media (max-width: 991px) {
  //   max-width: 100%;
  // }
`;

export const Card = styled(Paper).attrs({})`
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  overflow: hidden;
  padding: 0px 24px;
  ${p => p.full ? 'padding: 0px;' : 'padding: 0px 24px;'};
  ${p => p.noShadow && 'box-shadow: none !important;'}
  background: ${({ theme }) => theme.palette.colors.surfaceElevated} !important;
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  
`;

export const CardItem = styled.div`
  display: flex;
  gap: 4px;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: ${p => p.column ? 'column' : 'row'};
  text-transform: ${({ isTitle }) => (isTitle ? 'uppercase' : 'none')};
  border-bottom: ${({ theme, isLast }) => isLast ? 'none' : `1px solid ${theme.palette.colors.borderSoft}`};
  padding: 12px 0px;
  white-space: nowrap;
`;

export const CardItemTitle = styled.div.attrs({ isTitle: true })`
    color: ${({ theme }) => theme.palette.colors.subdued};
    font-family: Poppins;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
`;

export const CardItemText = styled.div.attrs()`
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
`;
